import styled from 'styled-components';
import Popper from '@material-ui/core/Popper';

// CONSTANTS
import { WHITE } from '@/constants/colors';

export const ShowMovieVotesStyled = styled.div`
  display: flex;

  .movie-votes__thumb {
    padding: 0 10px;

    display: flex;

    svg,
    p {
      color: ${WHITE};
    }

    p {
      margin-left: 6px;
    }

    svg {
      font-size: 2rem;
    }

    &.movie-votes__thumb--tooltip {
      cursor: pointer;
    }
  }
`;

export const ShowMovieVotesDetailsStyled = styled.div`
  overflow: hidden;

  .votes-details__title {
    margin-bottom: 8px;
  }

  p {
    max-width: 148px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const VotesTooltipPopperComponent = styled(Popper)`
  .MuiTooltip-tooltip {
    background-color: rgba(19, 20, 21, 0.9);
    padding: 16px;
    width: 180px;
  }

  .MuiTooltip-arrow {
    color: rgba(19, 20, 21, 0.9);
  }
`;
